import { ModelFactory } from "../../ModelFactory";
import { parseItemPermissions, PermissionMap } from "../../common/models/PermissionMap";
import { Customer, customerFactory } from "../../common/models/Customer";
import { Server, serverFactory } from "./Server";
import { SshKey, sshKeyFactory } from "./SshKey";
import { DeploymentStatus } from "../../common/models/DeploymentStatus";

export type SiteType = "shared_hosting_subscription" | "cluster_hosting" | "windhosting_site"
export class Site {
  constructor(
    public readonly id: string,
    public readonly displayName: string,
    public readonly name: string,
    public readonly notes: string | null,
    public readonly domain: string | null,
    public readonly aliasDomains: string[],
    public readonly deploymentStatus: DeploymentStatus,
    public readonly serverId: string,
    public readonly siteType: SiteType,
    public readonly certificate: string,
    public readonly customer: Customer | null,
    public readonly server: Server | null,
    public readonly deploymentDetails: SiteDeploymentDetails | null,
    public readonly sshKeys: SshKey[] | null,
    public readonly sshUserName: string | null,
    public readonly phpHandler: string | null,
    public readonly removeAt: Date | null,
    public readonly permissions: PermissionMap | null,
  ) {
  }
}

class SiteFactory extends ModelFactory<Site> {
  protected fromJson(json: any): Site {
    return new Site(
      json['id'],
      json['display_name'],
      json['name'],
      json['notes'],
      json['domain'],
      json['alias_domains'] ?? [],
      json['deployment_status'],
      json['server_id'],
      json['type'],
      json['certificate'],
      json['customer'] ? customerFactory.fromItemResponse(json['customer']) : null,
      json['server'] ? serverFactory.fromItemResponse(json['server']) : null,
      json['deployment_details'] ? siteDeploymentDetailsFactory.fromItemResponse(json['deployment_details']) : null,
      json['authorized_keys'] ? sshKeyFactory.fromItemsResponse(json['authorized_keys']) : [],
      json['ssh_username'] ?? null,
      json["php_handler"] ?? null,
      json['remove_at'] ? new Date(json['remove_at']) : null,
      parseItemPermissions(json['permissions']),
    );
  }
}
export const siteFactory = new SiteFactory();

export class SiteDeploymentDetails {
  constructor(
    public readonly name: string,
    public readonly phpHandler: string,
    public readonly ipAddresses: string[],
    public readonly databaseUsage: number,
    public readonly storageUsage: number,
    public readonly trafficUsage: number,
    public readonly additionalNginxSettings: string,
    public readonly additionalPhpSettings: string,
  ) { }
}

class SiteDeploymentDetailsFactory extends ModelFactory<SiteDeploymentDetails> {
  protected fromJson(json: any): SiteDeploymentDetails {
    return new SiteDeploymentDetails(
      json["name"],
      json["php_handler"],
      json["ip_addresses"],
      json["database_usage"],
      json["storage_usage"],
      json["traffic_usage"],
      json["additional_nginx_settings"],
      json["additional_php_settings"],
    );
  }
}
const siteDeploymentDetailsFactory = new SiteDeploymentDetailsFactory();
